import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const MasterMerchantProductFormValidations = {
    id: [
        { type: 'required', message: 'ID is required' }
    ],

    category_id: [
        { type: 'required', message: 'Category ID is required' }
    ],

    merchant_code: [
        { type: 'required', message: 'Merchant code is required' }
    ],

    provider_id: [
        { type: 'required', message: 'Provider ID is required' }
    ],

    product_code: [
        { type: 'required', message: 'Product code is required' }
    ],

    fee_merchant: [
        { type: 'required', message: 'Merchant fee is required' },
        { type: 'min', value: 0, message: 'Merchant fee must be zero or more' }
    ],

    fee_provider: [
        { type: 'required', message: 'Provider fee is required' },
        { type: 'min', value: 0, message: 'Provider fee must be zero or more' }
    ],

    fee: [
        { type: 'required', message: 'Fee is required' },
        { type: 'min', value: 0, message: 'Fee must be zero or more' }
    ],

    percent_price: [
        { type: 'required', message: 'Percent price is required' },
        { type: 'min', value: 0, message: 'Percent price must be zero or more' },
        { type: 'max', value: 100, message: 'Percent price cannot exceed 100%' }
    ],

    // active: [
    //     { type: 'required', message: 'Active status is required' }
    // ],

    // created_by: [
    //     { type: 'required', message: 'Created by is required' }
    // ]
};
